<script lang="ts">
  import type { Snippet } from "svelte";

  let {
    title,
    subtitle,
    pad = true,
    actions,
    children,
  }: {
    title?: string;
    subtitle?: string;
    pad?: boolean;
    actions?: Snippet;
    children: Snippet;
  } = $props();
</script>

<section
  class="bg-surface border border-border rounded-lg overflow-hidden shadow-sm"
>
  {#if title || actions}
    <header class="flex items-start gap-3 px-4.5 py-4 border-b border-border">
      <div class="min-w-0">
        {#if title}<h3 class="m-0 text-md font-bold text-ink">{title}</h3>{/if}
        {#if subtitle}<p class="mt-0.75 mb-0 text-sm text-muted">{subtitle}</p>{/if}
      </div>
      {#if actions}<div class="ml-auto flex gap-2 shrink-0">{@render actions()}</div>{/if}
    </header>
  {/if}
  <div class={pad ? "p-4.5" : ""}>
    {@render children()}
  </div>
</section>
